import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getUsers(_) {
      return axios({
        url: `${process.env.VUE_APP_URL}/apiUser`,
        method: 'GET',
      })
    },
    createUser(_, data) {
      return axios({
        method: 'POST',
        url: `${process.env.VUE_APP_URL}/apiUser`,
        data,
      })
    },
    deleteUser(_, clientId) {
      return axios({
        method: 'DELETE',
        url: `${process.env.VUE_APP_URL}/apiUser/${clientId}`,
      })
    },
    regenerateUser(_, clientId) {
      return axios({
        method: 'PUT',
        url: `${process.env.VUE_APP_URL}/apiUser/regenerate/${clientId}`,
      })
    },
  },
}
